import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getHelpTexts } from "modules/entity-repository/entity-repository-selectors";
import constants from "../../common/constants";

import { getLocale } from "modules/i18n/locale-selectors";
import { FormattedMessage } from "react-intl";
import { sanitizeHTMLString } from "../utils/text-utils";
import { getLocaleSpecificProp } from "../i18n/locale-utils";

const INSTRUCTION = "instruction";
const INFORMATION = "information";

class HelpTextModal extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    helpText: PropTypes.object
  };

  state = {
    activeTab: INFORMATION
  };

  getGuidanceText() {
    const { helpText, locale } = this.props;

    return sanitizeHTMLString(
      getLocaleSpecificProp(helpText.information, locale)
    );
  }
  render() {
    const { helpText } = this.props;
    if (!helpText) {
      return null;
    }

    return (
      <Fragment>
        <div className="consent-modal">
          <div className="consent-wrapper">
            <div className="title">
              <FormattedMessage id="app.show-help" />
            </div>
            <div
              className="consent-text "
              dangerouslySetInnerHTML={{
                __html: this.getGuidanceText()
              }}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapState = state => ({
  helpTexts: getHelpTexts(state),
  locale: getLocale(state)
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  helpText: stateProps.helpTexts[ownProps.type]
});

export default connect(
  mapState,
  null,
  mergeProps
)(HelpTextModal);



// WEBPACK FOOTER //
// ./src/modules/modal/help-text-modal.js